<template>
    <modal
        ref="modal"
        :title="modalTitle"
        class-name="customer-postcode-fee-modal"
        @close="handleClose"
    >
        <form
            ref="form"
            @submit.prevent="save"
        >
            <div class="form-group">
                <label for="cpf_service_fee">Service fee</label>
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text">£</span>
                    </div>
                    <input
                        id="cpf_service_fee"
                        v-model="form.service_fee"
                        type="number"
                        step="0.01"
                        min="0"
                        class="form-control"
                        :class="{ 'is-invalid': errors.service_fee }"
                    >
                </div>
                <error
                    :errors="errors"
                    name="service_fee"
                />
            </div>
            <div class="form-group">
                <label for="cpf_unit_fee">Unit fee</label>
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text">£</span>
                    </div>
                    <input
                        id="cpf_unit_fee"
                        v-model="form.unit_fee"
                        type="number"
                        step="0.01"
                        min="0"
                        class="form-control"
                        :class="{ 'is-invalid': errors.unit_fee }"
                    >
                </div>
                <error
                    :errors="errors"
                    name="unit_fee"
                />
            </div>
        </form>
        <template slot="footer">
            <div class="d-flex w-100 justify-content-between">
                <div>
                    <button
                        v-if="existingFee"
                        type="button"
                        class="btn btn-outline-danger"
                        :disabled="saving"
                        @click="confirmDelete"
                    >
                        <i class="fa fa-trash" /> Delete
                    </button>
                </div>
                <div>
                    <button
                        type="button"
                        class="btn btn-secondary"
                        @click="$refs.modal.close()"
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        class="btn btn-primary"
                        :disabled="saving"
                        @click="save"
                    >
                        {{ existingFee ? 'Save' : 'Add' }}
                    </button>
                </div>
            </div>
        </template>
    </modal>
</template>
<script>
import CustomerPostcodeFeeService from '../../../services/CustomerPostcodeFeeService';
import UsesErrors from '../../../mixins/UsesErrors';
import UsesInfoMessage from '../../../mixins/UsesInfoMessage';
import Modal from '../../modals/ModalComponent.vue';

export default {
    components: {
        Modal,
    },
    mixins: [UsesErrors, UsesInfoMessage],
    props: {
        customerId: {
            type: [String, Number],
            required: true,
        },
        existingFee: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            form: {
                service_fee: '',
                unit_fee: '',
            },
            saving: false,
        };
    },
    computed: {
        modalTitle() {
            return this.existingFee ? 'Edit custom postcode fee' : 'Set custom postcode fee';
        },
    },
    watch: {
        existingFee: {
            immediate: true,
            handler: function (fee) {
                if (fee && fee.id != null) {
                    this.form = {
                        service_fee: String(fee.service_fee),
                        unit_fee: String(fee.unit_fee),
                    };
                } else {
                    this.form = {
                        service_fee: '',
                        unit_fee: '',
                    };
                }
            },
        },
    },
    mounted() {
        var self = this;
        this.$nextTick(function () {
            if (self.$refs.modal) {
                self.$refs.modal.open();
            }
        });
    },
    methods: {
        handleClose() {
            this.$emit('close');
        },
        confirmDelete() {
            if (!window.confirm('Remove this custom postcode fee? Forms will use the default postcode-based fees again.')) {
                return;
            }
            this.saving = true;
            CustomerPostcodeFeeService.destroy(this.customerId).then(() => {
                if (this.$refs.modal) {
                    this.$refs.modal.close();
                }
                this.$emit('deleted');
                this.setInfoMessage('Custom postcode fee removed');
            }).catch(err => {
                if (err.response && err.response.data && err.response.data.errors) {
                    this.captureRequestErrors(err);
                } else {
                    this.showErrorMessage('Failed to remove postcode fee');
                }
            }).then(() => {
                this.saving = false;
            });
        },
        save() {
            this.clearErrors();
            const serviceFee = parseFloat(this.form.service_fee);
            const unitFee = parseFloat(this.form.unit_fee);
            const validationErrors = {};
            if (this.form.service_fee === '' || this.form.service_fee === null || isNaN(serviceFee)) {
                validationErrors.service_fee = ['Please enter a valid service fee'];
            }
            if (this.form.unit_fee === '' || this.form.unit_fee === null || isNaN(unitFee)) {
                validationErrors.unit_fee = ['Please enter a valid unit fee'];
            }
            if (Object.keys(validationErrors).length) {
                this.setErrors(validationErrors);
                return;
            }

            this.saving = true;
            const payload = {
                service_fee: serviceFee,
                unit_fee: unitFee,
            };
            const wasEditing = !!this.existingFee;
            CustomerPostcodeFeeService.save(this.customerId, payload).then(() => {
                if (this.$refs.modal) {
                    this.$refs.modal.close();
                }
                this.$emit('saved', { wasEditing });
                this.setInfoMessage(wasEditing ? 'Postcode fee updated' : 'Custom postcode fee saved');
            }).catch(err => {
                this.captureRequestErrors(err);
            }).then(() => {
                this.saving = false;
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/office/customers/CustomerPostcodeFeeModal.vue